import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AddonAccessService } from '../services/addon-access.service';

/**
 * Lets a route through only when the owner account holds the add-on named in
 * `data.requiredAddonKey`. Re-checks the approved add-ons on every entry and fails closed (no data,
 * failed request) to the existing no-access page. Combine with the existing auth / permission guards;
 * it does not replace them, and the backend still enforces entitlements.
 */
export const addonAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const addonKey = route.data['requiredAddonKey'] as string | undefined;
  if (!addonKey) {
    return true;
  }

  const addonAccess = inject(AddonAccessService);
  const router = inject(Router);

  return addonAccess
    .refresh()
    .pipe(
      map(() =>
        addonAccess.hasAccess(addonKey) ? true : router.createUrlTree(['/syncinns-pms/no-access']),
      ),
    );
};
